var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgWarningExclamationMedium(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.71875 12C3.71875 7.44365 7.4124 3.75 11.9688 3.75C16.5251 3.75 20.2188 7.44365 20.2188 12C20.2188 16.5563 16.5251 20.25 11.9688 20.25C7.4124 20.25 3.71875 16.5563 3.71875 12ZM11.9688 2.25C6.58397 2.25 2.21875 6.61522 2.21875 12C2.21875 17.3848 6.58397 21.75 11.9688 21.75C17.3535 21.75 21.7188 17.3848 21.7188 12C21.7188 6.61522 17.3535 2.25 11.9688 2.25ZM12.7188 9C12.7188 8.58579 12.383 8.25 11.9688 8.25C11.5545 8.25 11.2188 8.58579 11.2188 9V12.75C11.2188 13.1642 11.5545 13.5 11.9688 13.5C12.383 13.5 12.7188 13.1642 12.7188 12.75V9ZM11.9688 15C11.5545 15 11.2188 15.3358 11.2188 15.75V15.7575C11.2188 16.1717 11.5545 16.5075 11.9688 16.5075H11.9762C12.3905 16.5075 12.7262 16.1717 12.7262 15.7575V15.75C12.7262 15.3358 12.3905 15 11.9762 15H11.9688Z",
    fill: "#CCA319"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningExclamationMedium);
export default __webpack_public_path__ + "static/media/warning-exclamation-medium.0f2dbdf6416c65c5710acceabfb4ae2c.svg";
export { ForwardRef as ReactComponent };